module.exports = __webpack_public_path__ + "static/img/solutions.9b1aa915.png";